import controller from './tunnel.controller';
import template from './tunnel.view.html';

let TunnelComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default TunnelComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/tunnel/tunnel.component.js
 **/